var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWorkerSafety = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M25 20.8H1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h24c.3 0 .5.2.5.5s-.3.5-.5.5M14.7 13c-.3 0-.5-.2-.5-.5V6.3c0-.1-.1-.1-.2-.1h-2.1c-.1 0-.2.1-.2.1v6.2c0 .3-.2.5-.5.5s-.5-.2-.5-.5V6.3c0-.6.5-1.1 1.2-1.1H14c.6 0 1.2.5 1.2 1.1v6.2c0 .3-.2.5-.5.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M7.6 14c-.2 0-.4-.1-.4-.3l-1.7-3.1c-.1-.2 0-.5.2-.7.2-.1.5 0 .7.2L8 13.2c.1.2 0 .5-.2.7-.1.1-.1.1-.2.1M18.5 14c-.1 0-.2 0-.2-.1-.2-.1-.3-.4-.2-.7l1.7-3.1c.1-.2.4-.3.7-.2.2.1.3.4.2.7L19 13.7c-.1.2-.3.3-.5.3"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "m11.6 18.7-1.5-1.6c-.2-.2-.2-.5 0-.7s.5-.2.7 0l.8.9 3.5-2.8c.2-.2.5-.1.7.1s.1.5-.1.7z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M23.8 19.5c-.3 0-.5-.2-.5-.5 0-5.5-3.5-10.2-8.4-11.2-.3-.1-.4-.3-.4-.6.1-.3.3-.4.6-.4 5.3 1.1 9.2 6.2 9.2 12.2 0 .3-.3.5-.5.5M2.2 19.5c-.3 0-.5-.2-.5-.5 0-6 3.9-11.1 9.3-12.2.3-.1.5.1.6.4s-.1.5-.4.6c-4.9 1-8.5 5.7-8.5 11.2 0 .3-.2.5-.5.5"
})));
export default SvgWorkerSafety;